import { APPLICATION_ROUTES, Endpoint, MODULE_ROUTES, Route } from '@philips-emr/hpms-stipulator-commons';
import { Value } from '@philips-emr/tws-core';
import { AuthenticationService, HttpService, msg } from '@philips-emr/tws-core/lib/services';
import HistoryService from '@philips-emr/tws-core/lib/services/history-service';
import { RequestResponse } from '@philips-emr/tws-core/lib/services/http-service';
import { applicationModuleRegistry, isApplicationModule } from '@philips-emr/tws-foundation';

interface OAuthResponse {
  access_token: string;
  expires_in: number;
  refresh_expires: number;
  refresh_token: string;
  token_type: string;
}

class Audit {

  addRouteListener(): Function {
    return HistoryService.addListener((path: string) => {

      //@ts-ignore
      return this.routeChangeLog(path).then(response => {
        if (!response || !response.body) {
          return Promise.resolve();
        }
        const oAuth = response.body as OAuthResponse;
        return AuthenticationService.updateJWTToken(oAuth);
      });

    });
  }

  routeChangeLog(path: string): Promise<RequestResponse> {

    if (path.endsWith('/')) {
      path = path.slice(0, -1);
    }

    const rotas: { [k: string]: string } = {
      [this.parseRoute(`${MODULE_ROUTES.BENEFICIARIOS}${APPLICATION_ROUTES.INCLUSAO_BENEFICIARIO}`)]: msg('beneficiario.inclusao'),
      [this.parseRoute(Route.MEUS_DADOS)]: msg('$expression.$962143'),
    };

    applicationModuleRegistry.getAll().forEach(module => {
      if (isApplicationModule(module)) {
        rotas[this.parseRoute(module.route)] = msg(module.name);
      }
    });

    const nmFuncao = rotas[this.parseCurrentRoute(path)];

    if (!nmFuncao) {
      //@ts-ignore
      return Promise.resolve();
    }

    const body = {
      rota: path,
      nmFuncao,
      refresh_token: localStorage.getItem('refresh_token'),
    };

    return Audit.logAcessoFuncao(body);
  }

  static logAcessoFuncao(requestBody: Record<string, Value>): Promise<RequestResponse> {
    return HttpService.post(Endpoint.POST.ACESSO_FUNCAO, {}, { body: requestBody });
  }

  parseCurrentRoute(route: string): string {
    const regex = /\d+/g;
    return route.replace(regex, '');
  }

  parseRoute(route: string): string {
    const regex = /:\w+/g;
    return route.replace(regex, '');
  }

}

export default Audit;
